/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Host, Input, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { HelpIdDirective, HelpProvider } from '@gh/common-shared';

import { isEmpty } from 'lodash';

import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'gh-dialog-header',
  template: require('./dialog-header.component.html'),
  styles: [require('./dialog-header.component.scss')],
})
export class DialogHeaderComponent {
  @Input() title: string;

  constructor(public dialogRef: MatDialogRef<any>,
              private dialog: DialogComponent,
              private helpProvider: HelpProvider,
              @Optional() @Host() private help?: HelpIdDirective) {
  }

  get hasManual(): boolean {
    return !isEmpty(this.help && this.help.helpId);
  }

  get closable(): boolean {
    return this.dialog.closable;
  }

  onManualOpen(): void {
    const helpId = this.help && this.help.helpId;
    if (helpId) {
      this.helpProvider.open(helpId);
    }
  }

  close(): void {
    this.dialog.close();
  }
}
